export const ProductType = {
  RECOMMENDED: 1,
  TOP_SELLING: 2,
  RECENT_VIEWED: 3,
  MOST_SEARCHED: 4,
  CONTINUE_SEARCH: 5,
  TOP_Brands: 7,
  LATEST: 2
};
export const substituteStatus = {
  REQUESTED: 0,
  APPROVED: 1,
  REJECTED: 2
}